// extracted by mini-css-extract-plugin
module.exports = {"section":"_2ZU4I","disclaimer":"Ttz9_"};